import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  isDefinedString,
  isNullOrUndefined,
  isPositiveNumber
} from "et3-type-guards";
import { useState } from "react";

import { TEt3TextInput } from "../../../TypesNEW";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import Et3InputField from "./InputField";
import {
  FIELD_BLOCK_HEIGHT_WITH_LABEL,
  FIELD_BORDER,
  FIELD_BORDER_FOCUS,
  FIELD_GAP,
  FIELD_HEIGHT,
  FIELD_ICON_SIZE,
  FIELD_INPUT_CLASS,
  FIELD_INPUT_FONT_SIZE,
  FIELD_LABEL_FONT_SIZE,
  FIELD_LABEL_LETTER_SPACING,
  FIELD_LABEL_HEIGHT,
  FIELD_PADDING_X,
  FIELD_RADIUS,
  FIELD_SHADOW,
  FIELD_SHADOW_FOCUS,
  FIELD_TRANSITION
} from "./text-input-constants";

const Et3TextInput = withLiteObserverAndTheme<TEt3TextInput>((props) => {
  const {
    id,
    placeHolder,
    label,
    icon,
    theme,
    onChoose,
    onBlur,
    type,
    value,
    style,
    onEnter,
    size
  } = props;
  const { colors, unitX, unitY, getFontSize, getFontType } = theme;
  const [isFocused, setIsFocused] = useState(false);
  const valueEdited =
    type === "number"
      ? !isPositiveNumber(value)
        ? placeHolder
        : value
      : value;
  const isExtraSmallWidth = size === "EXTRA_SMALL";
  const isSmallWidth = size === "SMALL";
  const isMediumWidth = size === "MEDIUM";
  const isMediumPlusWidth = size === "MEDIUM_PLUS";
  const isLargeWidth = size === "LARGE";
  const hasLabel = isDefinedString(label);
  const hasIcon = !isNullOrUndefined(icon);

  const width = isExtraSmallWidth
    ? 100
    : isSmallWidth
      ? 200
      : isMediumWidth
        ? 280
        : isMediumPlusWidth
          ? 450
          : isLargeWidth
            ? 1020
            : 1200;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="flex-start"
      withShadow={false}
      width={width}
      height={0}
      color={colors.all.transparent}
      style={{
        ...style,
        minHeight: hasLabel
          ? FIELD_BLOCK_HEIGHT_WITH_LABEL * unitY
          : FIELD_HEIGHT * unitY,
        height: hasLabel
          ? FIELD_BLOCK_HEIGHT_WITH_LABEL * unitY
          : FIELD_HEIGHT * unitY
      }}
      onClick={() => {}}
    >
      {!hasLabel ? null : (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={width}
          height={FIELD_LABEL_HEIGHT}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={FIELD_LABEL_FONT_SIZE}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              margin: 0,
              textAlign: "left",
              letterSpacing: FIELD_LABEL_LETTER_SPACING * unitX
            }}
          />
        </ET3Div>
      )}
      <div
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
          minWidth: 0,
          height: FIELD_HEIGHT * unitY,
          backgroundColor: colors.all.white,
          borderRadius: FIELD_RADIUS * unitX,
          border: isFocused ? FIELD_BORDER_FOCUS : FIELD_BORDER,
          boxShadow: isFocused ? FIELD_SHADOW_FOCUS : FIELD_SHADOW,
          transition: FIELD_TRANSITION,
          paddingLeft: FIELD_PADDING_X * unitX,
          paddingRight: FIELD_PADDING_X * unitX,
          gap: FIELD_GAP * unitX,
          overflow: "hidden"
        }}
      >
        {!hasIcon ? null : (
          <FontAwesomeIcon
            icon={icon}
            color={isFocused ? colors.all.bondiBlue : colors.all.gray}
            style={{
              width: FIELD_ICON_SIZE * unitX,
              height: FIELD_ICON_SIZE * unitY,
              flexShrink: 0,
              transition: FIELD_TRANSITION
            }}
          />
        )}
        <Et3InputField
          id={id}
          type={type}
          fieldClassName={FIELD_INPUT_CLASS}
          label={placeHolder}
          value={valueEdited}
          onChoose={onChoose}
          onBlur={onBlur}
          style={{
            boxSizing: "border-box",
            alignSelf: "stretch",
            border: 0,
            padding: 0,
            backgroundColor: colors.all.transparent,
            color: colors.all.maastrichtBlue,
            fontFamily: getFontType("MEDIUM"),
            fontSize: getFontSize(FIELD_INPUT_FONT_SIZE),
            flexGrow: 1,
            minWidth: 0
          }}
          onEnter={onEnter}
        />
      </div>
    </ET3Div>
  );
});
export default Et3TextInput;
